import * as React from 'react';
import { translate } from 'react-i18next';
import { IWardrobeItemListCard } from 'models/wardrobe/wardrobeitemlistcard';
import { IItemCardProps, IItemCardButtonsProps } from 'models/itemcard';
import { ItemCardButtons, LikeButton } from 'components';
import * as c from 'models/constants';
import { NodeType } from 'models/enums/nodetype/nodetype';
import { IAuthContext } from 'models/common';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { setWardrobeItemPictureUrl } from 'helpers/common';

require('./style.css');
interface IProps extends IItemCardProps {
	item: IWardrobeItemListCard;
	t?: (key: string, options?: any) => string;
	unwishItem?: (itemType: NodeType, itemId: string) => void;
	wishlistItem?: (itemType: NodeType, itemId: string) => void;
	context?: IAuthContext;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class WardrobeItemCardComponent extends React.Component<IProps, any> {
	private showWardrobeItemDropdownMenu: boolean = false;
	private wardrobeItemDropdownButtonElement: HTMLElement;

	constructor(props) {
		super(props);

		this.editItem = this.editItem.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.likeItem = this.likeItem.bind(this);
		this.unlikeItem = this.unlikeItem.bind(this);
		this.goToCard = this.goToCard.bind(this);
		this.selectItem = this.selectItem.bind(this);
		this.handleWishlist = this.handleWishlist.bind(this);
		this.handleUnwish = this.handleUnwish.bind(this);

		this.handleShowWardrobeItemContextMenuClicked = this.handleShowWardrobeItemContextMenuClicked.bind(this);
		this.handleWardrobeItemContextMenuClickedOutsite = this.handleWardrobeItemContextMenuClickedOutsite.bind(this);
	}

	public goToCard(e: React.SyntheticEvent, id: string, type: string, target?: string) {
		e.preventDefault();
		if (this.props.goToCard) {
			this.props.goToCard(id, type, target);
		}
	}

	public likeItem() {
		if (this.props.likeItem) {
			this.props.likeItem(NodeType.WardrobeItem, this.props.item.id);
		}
	}

	public unlikeItem() {
		if (this.props.unlikeItem) {
			this.props.unlikeItem(NodeType.WardrobeItem, this.props.item.id);
		}
	}

	private selectItem() {
		if (!this.props.item.isSelected) {
			this.props.selectItemObject(this.props.item);
		}
	}

	private renderSelectButton(isSelected: boolean = false) {
		let selectBtn: JSX.Element = null;
		if (this.props.selectItemObject && (isSelected !== undefined || isSelected !== null)) {
			selectBtn = (
				<div className="checkboxPosition">
					<label className="container">
						<span className="checkmark" onClick={this.selectItem} />
					</label>
				</div>
			);
		}
		return selectBtn;
	}

	public editItem() {
		if (this.props.editItem !== undefined) {
			this.props.editItem(this.props.item.id);
		}
	}

	public deleteItem(e: any) {
		e.cancelBubble = true;
		if (e.stopPropagation) {
			e.stopPropagation();
		}

		if (this.props.deleteItem !== undefined) {
			this.props.deleteItem('', this.props.item.id);
		}
	}

	private handleWishlist() {
		if (this.props.wishlistItem) {
			this.props.wishlistItem(NodeType.WardrobeItem, this.props.item.id);
			this.showWardrobeItemDropdownMenu = !this.showWardrobeItemDropdownMenu;
			this.forceUpdate();
		}
	}

	private handleUnwish() {
		if (this.props.unwishItem) {
			this.props.unwishItem(NodeType.WardrobeItem, this.props.item.id);
			this.showWardrobeItemDropdownMenu = !this.showWardrobeItemDropdownMenu;
			this.forceUpdate();
		}
	}

	private handleShowWardrobeItemContextMenuClicked() {
		this.showWardrobeItemDropdownMenu = !this.showWardrobeItemDropdownMenu;
		this.forceUpdate();
	}

	private handleWardrobeItemContextMenuClickedOutsite(e: any) {
		if (!this.wardrobeItemDropdownButtonElement.contains(e.target)) {
			if (this.showWardrobeItemDropdownMenu) {
				this.showWardrobeItemDropdownMenu = false;
				this.forceUpdate();
			}
		}
	}

	public render() {
		const { currentUserId, t } = this.props;
		const { picture, name, userId, isLiked, isSelected, addedBy, followersCount } = this.props.item;
		const { isAuthenticated, signinRedirect } = this.props.context;

		const isMyItem = currentUserId === userId;

		const itemCardButtonsProps: IItemCardButtonsProps = {
			editItem: this.props.editItem && isMyItem ? this.editItem : null,
			deleteItem: this.props.deleteItem !== undefined && currentUserId === userId ? this.deleteItem : null,
		};

		const id = JSON.parse(this.props.item.entityId).id;

		return (
			<div className={'commonItemCard wardrobeItemCard ' + (isMyItem ? 'myItem' : '')}>
				{this.renderSelectButton(isSelected)}
				{!this.props.disableActions ? (
					<LikeButton
						isLiked={isLiked}
						likeItem={this.likeItem}
						unlikeItem={this.unlikeItem}
						isAuthenticated={isAuthenticated}
						signinRedirect={signinRedirect}
					/>
				) : null}
				<a
					href="#"
					onClick={(e) => this.goToCard(e, JSON.parse(this.props.item.entityId).id, c.NODE_TYPE_WARDROBE)}
					className="imageHolder"
					style={{ backgroundImage: `url(${setWardrobeItemPictureUrl(picture).src})` }}
				>
					<img {...setWardrobeItemPictureUrl(picture)} className="image" />
				</a>
				<div className="itemDetail">
					<div className="outfitName">
						<a
							href="#"
							onClick={(e) => {
								this.goToCard(e, id, c.NODE_TYPE_WARDROBE);
							}}
						>
							{name}
						</a>
					</div>
					<div className="byName">
						<a
							href="#"
							onClick={(e) => {
								this.goToCard(e, userId, c.NODE_TYPE_USER);
							}}
						>
							{addedBy}
						</a>
					</div>
					<div className="likes">{followersCount + ' ' + t('BSPortal_Common_Followers')}</div>
				</div>
				{!this.props.disableActions ? <ItemCardButtons {...itemCardButtonsProps} /> : null}
			</div>
		);
	}
}
const WardrobeItemCard = withAuthContext(WardrobeItemCardComponent);
export { WardrobeItemCard };
